import { EndpointWithoutRequest, Http } from "Application/Helpers/BaseEndpoint";
import { AppUrls } from "AppUrls";

export class MentorsCountResponse {
    public current: number = 0;
    public past: number = 0;
}

export class GET_GetMentorsCountEndpoint extends EndpointWithoutRequest<any> {
    constructor() {
        super();
        this.verb(Http.Get);
        this.path(AppUrls.Server.Mentor.GetMentorsCount);
    }

    public async HandleResponseAsync(response: MentorsCountResponse): Promise<any> {
        return response;
    }
}
